import { Service } from '@roc/feature-app-core';

const url = {
  GET_SALES_MANAGEMENT_DASHBOARD: '/api/v1/lender/getSalesManagementDashboard',
  GET_OUTREACH_OVERALL_DASHBOARD: '/api/v1/lender/getOutreachOverallDashboard',
  GET_JOURNEY_BUILDER_DASHBOARD: '/api/v1/lender/getJourneyBuilderDashboard',
  GET_JOURNEY_BUILDER_OVERDUE_STEPS: '/api/v1/lender/getJourneyBuilderOverdueSteps'
};

export class SalesManagementService extends Service {

  getSalesManagementGrid(
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    filters: string,
    dropdownFilters: string,
    businessUnit: string
  ) {
    return this.get(
      url.GET_SALES_MANAGEMENT_DASHBOARD,
      {
        page,
        pageSize,
        sortBy,
        sortDir,
        filters,
        dropdownFilters,
        businessUnit
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getOutreachOverallGrid(
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    filters: string,
    dropdownFilters: Record<string, any>,
  ) {
    return this.get(
      url.GET_OUTREACH_OVERALL_DASHBOARD,
      {
        page,
        pageSize,
        sortBy,
        sortDir,
        filters,
        ...(dropdownFilters ?? {}),
      },
      { disableGlobalLoading: true }
    );
  }

  getJourneyBuilderGrid(
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    filters: string,
    dropdownFilters: string,
    businessUnit: string
  ) {
    return this.get(
      url.GET_JOURNEY_BUILDER_DASHBOARD,
      {
        page,
        pageSize,
        sortBy,
        sortDir,
        filters,
        dropdownFilters,
        businessUnit
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getJourneyBuilderOverdueStepsGrid(
    userId: number,
    page: number,
    pageSize: number,
    sortBy: string,
    sortDir: string,
    filters: string
  ) {
    return this.get(
      url.GET_JOURNEY_BUILDER_OVERDUE_STEPS,
      {
        userId,
        page,
        pageSize,
        sortBy,
        sortDir,
        filters
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

}
